module.exports = __webpack_public_path__ + "static/media/techSheets.4ff63748.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/BatchDownloads/img/techSheets.png
// module id = 818
// module chunks = 0